export default {
  default: () => import("/apps/src/ound-front/source/apps/shop-web/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/apps/src/ound-front/source/apps/shop-web/layouts/empty.vue").then(m => m.default || m)
}